import useQueryPolicies from "ApiLayer/Policies/queryPolicies";
import { TableColumn, DataSource } from "components/molecules/Table";
import { buildCarbonPoliciesTableData, CarbonPoliciesTableColumns } from "./CarbonPoliciesPage.helpers";

interface CarbonPoliciesDataResult {
    columns: TableColumn[];
    dataSource: DataSource[];
    isLoading: boolean;
}

export const useCarbonPoliciesData = (): CarbonPoliciesDataResult => {
    const { data: policiesResponse, isLoading } = useQueryPolicies();

    if (!policiesResponse || isLoading) {
        return {
            columns: [],
            dataSource: [],
            isLoading,
        };
    }

    const { columns, dataSource: carbonPoliciesTableData } = buildCarbonPoliciesTableData(
        policiesResponse,
        CarbonPoliciesTableColumns
    );

    return {
        columns,
        dataSource: carbonPoliciesTableData,
        isLoading,
    };
};
